import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/my-scopes`

export async function getAll() {
  return getWithRedirect(URL)
}

export async function update(names: string[]) {
  return Axios.put(URL, { data: { names } }, parseAuthenticationHeader())
}
